import Vue from "vue";
import Vuex from "vuex";

import zoom from "./zoom.js";

const modules = {
  zoom,
};

Vue.use(Vuex);

export default new Vuex.Store({
  modules: Object.keys(modules).reduce((acc, k) => {
    acc[k] = {
      ...modules[k],
      namespaced: true,
    };
    return acc;
  }, {}),
});
